import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Table } from "reactstrap";
import { getPublicPermissionDocumentById } from "services/Permission";
import moment from "moment";

const DocumentControl = () => {
  const [docData, setDocData] = useState(undefined);

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    try {
      const res = (await getPublicPermissionDocumentById(id)).data;
      setDocData(res?.data);
    } catch (error) {
      console.log("fetchData error", error);
    }
  };
  return (
    <div
      style={{
        height: "100vh",
        background: "#fff",
        padding: "1rem 4rem",
      }}
    >
      {!docData ? (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 20,
            }}
          >
            {/* <img src={tourismLogo} style={{ maxWidth: "120px" }} /> */}
            <h2 className="" style={{ fontWeight: "bolder" }}>
              Turizm İnformasiya Sistemi
            </h2>
            <h4 style={{ fontFamily: "monospace", fontWeight: "bold" }}>
              data.tourism.gov.az
            </h4>
          </div>

          <h1
            className="text-center mt-4 mb-4 text-xl"
            style={{ fontWeight: "bold" }}
          >
            Xüsusi rejim zonalarına səfər icazəsi
          </h1>

          <div className="px-8 mt-6 mb-10">
            <h2 style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
              İcazə sənədinin nömrəsi № {docData?.documentId}
            </h2>
            <p>
              Sənədin yaranma tarixi:{" "}
              {moment(docData?.createdAt).format("DD:MM:YYYY")}
            </p>
          </div>

          <div className="px-8">
            <Table responsive>
              <thead style={{ backgroundColor: "#E4E6EF" }}>
                <tr>
                  <th>#</th>
                  <th>Turistin Adı</th>
                  <th>Turistin Soyadı</th>
                  <th>Turistin Ata Adı</th>
                  <th>Avtomobil Markası</th>
                  <th>Avtomobil Nömrəsi</th>
                  <th>Avtomobil Rəngi</th>
                </tr>
              </thead>
              <tbody>
                {docData?.tourists.map((tourist, ind) => (
                  <tr>
                    <td>{ind + 1}</td>
                    <td>{tourist?.name}</td>
                    <td>{tourist?.surname}</td>
                    <td>{tourist?.fatherName}</td>
                    <td>{tourist?.vehicle?.brand}</td>
                    <td>{tourist?.vehicle?.numberPlate}</td>
                    <td>{tourist?.vehicle?.color}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <h1
            style={{
              fontSize: "4rem",
            }}
          >
            Sənəd Tapılmadı
          </h1>
        </div>
      )}
    </div>
  );
};

export default DocumentControl;
